import React from 'react';

import { createIcon } from '../createIcon';

function SvgWork(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M7.355 2.8V1.54h-2.71V2.8h2.71zM1.16 3.863v6.58h9.678v-6.58H1.16zm2.323-1.202v-.948c0-.74.604-1.334 1.355-1.334H7.16c.75 0 1.355.594 1.355 1.334v.948h2.13c.75 0 1.354.593 1.354 1.334v6.275a1.34 1.34 0 01-1.355 1.335h-9.29A1.34 1.34 0 010 10.27l.006-6.275c0-.741.599-1.334 1.349-1.334h2.129z"
          id="Work__svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <g transform="translate(2 2)">
          <path d="M0 0h12v12H0z" />
          <use fill="currentColor" xlinkHref="#Work__svg__a" />
        </g>
      </g>
    </svg>
  );
}

export const WorkOutlinedIcon = createIcon(SvgWork, 'WorkOutlinedIcon');
